import React, { Component } from 'react'

import './style.scss'

const PillTabs = ({ data, handleChange, activeItem }) => (
  <div className="clearfix">
    <div className="c-pill-tab-parent float-left">
      {data.edges.map(tab => (
        <button
          key={tab.node.id}
          onClick={() => {
            handleChange(tab)
          }}
          className={`c-pill-tab  ${activeItem === tab && 'is-active'}`}
          key={tab.node.name}
        >
          {tab.node.name}
        </button>
      ))}
    </div>
  </div>
)

export default PillTabs
